import { CoreMenu } from '@core/types';

export const menu: CoreMenu[] = [
  {
    id: 'smartcity-operation-collapsible',
    title: 'Vận hành',
    type: 'collapsible',
    importIcon: 'Activity',
    icon: 'activity',
    children: [
      {
        id: 'smartcity-camera',
        title: 'Giám sát Camera',
        type: 'item',
        importIcon: 'Video',
        icon: 'video',
        color: 'success',
        url: 'camera'
      },
      {
        id: 'smartcity-camera-manage',
        title: 'Cấu hình Camera',
        type: 'item',
        importIcon: 'Camera',
        icon: 'camera',
        color: 'primary',
        url: 'camera-manage'
      },
      {
        id: 'smartcity-dashboard',
        title: 'Bảng điều khiển',
        type: 'item',
        importIcon: 'LayoutDashboard',
        icon: 'layout-dashboard',
        color: 'primary',
        url: 'dashboard'
      },
      {
        id: 'smartcity-traffic-map',
        title: 'Quản lý địa điểm',
        type: 'item',
        importIcon: 'Map',
        icon: 'map',
        color: 'info',
        url: 'traffic-map'
      }
    ]
  },
  {
    id: 'smartcity-ai-collapsible',
    title: 'Sự kiện AI',
    type: 'collapsible',
    importIcon: 'Info',
    icon: 'info',
    children: [
      {
        id: 'smartcity-ai-report',
        title: 'Báo cáo tổng hợp',
        type: 'item',
        importIcon: 'ChartPie',
        icon: 'chart-pie',
        color: 'primary',
        url: 'ai-report'
      },
      {
        id: 'smartcity-lpr-log',
        title: 'Sự kiện phương tiện',
        type: 'item',
        importIcon: 'Car',
        icon: 'car',
        color: 'warning',
        url: 'lpr-log'
      },
      {
        id: 'smartcity-face-events',
        title: 'Nhận diện khuôn mặt',
        type: 'item',
        importIcon: 'Users',
        icon: 'users',
        color: 'primary',
        url: 'face-events'
      },
      {
        id: 'smartcity-behavior-events',
        title: 'Sự kiện hành vi',
        type: 'item',
        importIcon: 'Activity',
        icon: 'activity',
        color: 'warning',
        url: 'behavior-events'
      },
      {
        id: 'smartcity-fire-events',
        title: 'Sự kiện cháy nổ',
        type: 'item',
        importIcon: 'Flame',
        icon: 'flame',
        color: 'danger',
        url: 'fire-events'
      },
      {
        id: 'smartcity-ai-search',
        title: 'Tìm kiếm thông minh',
        type: 'item',
        importIcon: 'Search',
        icon: 'search',
        color: 'info',
        url: 'ai-search'
      }
    ]
  },
  {
    id: 'smartcity-access-collapsible',
    title: 'Quyền truy cập',
    type: 'collapsible',
    importIcon: 'Users',
    icon: 'users',
    children: [
      {
        id: 'smartcity-user-manage',
        title: 'Người dùng',
        type: 'item',
        importIcon: 'Users',
        icon: 'users',
        color: 'primary',
        url: 'user-manage'
      },
      {
        id: 'smartcity-organization',
        title: 'Tổ chức',
        type: 'item',
        importIcon: 'Building2',
        icon: 'building-2',
        color: 'primary',
        url: 'organization'
      }
    ]
  },
  {
    id: 'smartcity-alert-collapsible',
    title: 'Cảnh báo',
    type: 'collapsible',
    importIcon: 'Bell',
    icon: 'bell',
    children: [
      {
        id: 'smartcity-alert-rules',
        title: 'Cấu hình thông báo',
        type: 'item',
        importIcon: 'BellRing',
        icon: 'bell-ring',
        color: 'danger',
        url: 'alert-rules'
      },
      {
        id: 'smartcity-watchlist',
        title: 'Danh sách theo dõi',
        type: 'item',
        importIcon: 'ShieldAlert',
        icon: 'shield-alert',
        color: 'dark',
        url: 'watchlist'
      }
    ]
  },
  {
    id: 'smartcity-infra-collapsible',
    title: 'Hạ tầng',
    type: 'collapsible',
    importIcon: 'Server',
    icon: 'server',
    children: [
      {
        id: 'smartcity-devices',
        title: 'Quản lý AI BOX',
        type: 'item',
        importIcon: 'Cpu',
        icon: 'cpu',
        color: 'primary',
        url: 'devices'
      },
      {
        id: 'smartcity-infra-ops',
        title: 'Quản trị hạ tầng',
        type: 'item',
        importIcon: 'Server',
        icon: 'server',
        color: 'info',
        url: 'infra-ops'
      }
    ]
  }
];
